// extracted by mini-css-extract-plugin
module.exports = {"SettingsContent":"account_SettingsContent__fSGrS","AccountModule":"account_AccountModule__3C7-8","WarningText":"account_WarningText__3tCYZ","spinner":"account_spinner__BM4q0"};